import { Link } from "react-router-dom";
import { LayoutDashboard, PenSquare, MessagesSquare, Bell, UserRound, ShieldCheck, Globe, LifeBuoy } from "lucide-react";
import DashboardShell from "./DashboardShell";
import NotificationBell from "./NotificationBell";

const NAV = [
  { to: "/mon-espace", label: "Tableau de bord", icon: LayoutDashboard, end: true, id: "user-dashboard" },
  { to: "/mon-espace/deposer", label: "Déposer un feedback", icon: PenSquare, id: "user-give" },
  { to: "/mon-espace/feedbacks", label: "Mes feedbacks", icon: MessagesSquare, id: "user-feedbacks" },
  { to: "/mon-espace/notifications", label: "Notifications", icon: Bell, id: "user-notifications" },
  { to: "/mon-espace/support", label: "Support", icon: LifeBuoy, id: "user-support" },
  { to: "/mon-espace/profil", label: "Mon profil", icon: UserRound, id: "user-profile" },
  { to: "/mon-espace/confidentialite", label: "Confidentialité", icon: ShieldCheck, id: "user-privacy" },
];

export default function UserLayout() {
  return (
    <DashboardShell variant="user" nav={NAV}
      headerSlot={<>
        <Link to="/" className="hidden items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900 sm:flex" data-testid="user-back-site"><Globe className="h-4 w-4" />Site public</Link>
        <NotificationBell base="/me/notifications" />
      </>} />
  );
}
